import { createStorefrontApiClient } from "@shopify/storefront-api-client"

const client = createStorefrontApiClient({
  storeDomain: process.env.GATSBY_MYSHOPIFY_URL,
  apiVersion: process.env.GATSBY_SHOPIFY_API_VERSION,
  publicAccessToken: process.env.GATSBY_SHOPIFY_API_TOKEN,
})

export default client
